
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { SharedModules } from '@shared/shared.modules';
import { ConfigModule } from '@spartacus/core';
import { AppRoutingModule } from "@spartacus/storefront";
import { environment } from '../environments/environment';
import { CustomConfigurationModule } from './custom/config/custom-configuration.module';
import { CategoryInformationModule } from './custom/functions/category-information/category-information.module';
import { ConfigDebugModule } from './custom/functions/config-debug/config-debug.module';
import { devDisplayConfig } from './custom/functions/config-debug/default-display.config';
import { CustomFunctionsModule } from './custom/functions/custom-functions.module';
import { UserProfilesModule } from './custom/functions/user-profiles/user-profiles.module';
import { CustomTranslationsModule } from './custom/translations/custom-translations.module';
import { SpartacusModule } from './spartacus/spartacus.module';

registerLocaleData(localeDe);

const devImports = [];
if (!environment.production) {
  devImports.push(StoreDevtoolsModule.instrument({ connectInZone: true }));
  devImports.push(
    ConfigModule.withConfig(devDisplayConfig)
  );
}

@NgModule({
  imports: [
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    ConfigDebugModule,
    CustomFunctionsModule,
    CustomConfigurationModule,
    CustomTranslationsModule,
    UserProfilesModule,
    CategoryInformationModule,
    SharedModules,
    ...devImports,
  ]
})

export class AppModule {
}
